import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { VisibilityRootState } from "../../store/VisibilityStore";

import classes from "./Dewar.module.scss";

interface IProps {
	openVirtualShipment?: (name: string) => void;
	openEndToEndShipment?: (orderId: string) => void;
}

export const Dewar = ({ openVirtualShipment, openEndToEndShipment }: IProps): JSX.Element => {
	const shipment = useSelector((state: VisibilityRootState) => state.Visibility.shipment, shallowEqual);
	const orderId = useSelector((state: VisibilityRootState) => state.Visibility.orderId, shallowEqual);
	const device = useSelector((state: VisibilityRootState) => state.Visibility.device, shallowEqual);
	const isVirtualShipment = useSelector((state: VisibilityRootState) => state.Visibility.isVirtualShipment, shallowEqual);

	const onClickVirtualShipmentHandler = (event: React.MouseEvent<HTMLSpanElement>): void => {
		event.preventDefault();
		if (openVirtualShipment && shipment?.name) {
			openVirtualShipment(shipment.name);
		}
	};

	const onClickEndToEndShipmentHandler = (event: React.MouseEvent<HTMLSpanElement>): void => {
		event.preventDefault();
		if (openEndToEndShipment && shipment?.masterTrackingNo) {
			openEndToEndShipment(shipment.masterTrackingNo);
		}
	};

	return (
		<div className={classes.dewar}>
			<span>HAWB {shipment?.masterTrackingNo}</span>
			<span className={classes.separator}>|</span>
			{shipment?.name && (<span>Client Id {shipment?.name}</span>)}
			{shipment?.name && (<span className={classes.separator}>|</span>)}
			<span>Container {shipment?.cargoes[0]?.containerId}</span>
			<span className={classes.separator}>|</span>
			<span>Device {device?.displayName}</span>
			{isVirtualShipment && openVirtualShipment && (<span className={classes.separator}>|</span>)}
			{isVirtualShipment && openVirtualShipment && (
				<span className={classes.action} onClick={onClickVirtualShipmentHandler} >
					Open end-to-end shipment
				</span>
			)}
			{shipment?.leg && shipment.leg === "End-to-End" && shipment.masterTrackingNo.toUpperCase() !== orderId?.toUpperCase() && openEndToEndShipment && (
				<span className={classes.separator}>|</span>
			)}
			{shipment?.leg && shipment.leg === "End-to-End" && shipment.masterTrackingNo.toUpperCase() !== orderId?.toUpperCase() && openEndToEndShipment && (
				<span className={classes.action} onClick={onClickEndToEndShipmentHandler} >
								Open end-to-end shipment
				</span>
			)}
		</div>
	);
};
